__turbopack_context__.v({
  "description": "addon-sphere-row-module__SJ9uIW__description",
  "explore": "addon-sphere-row-module__SJ9uIW__explore",
  "item": "addon-sphere-row-module__SJ9uIW__item",
  "ktalk": "addon-sphere-row-module__SJ9uIW__ktalk",
  "listen": "addon-sphere-row-module__SJ9uIW__listen",
  "pause": "addon-sphere-row-module__SJ9uIW__pause",
  "pauseBar": "addon-sphere-row-module__SJ9uIW__pauseBar",
  "pillSm": "addon-sphere-row-module__SJ9uIW__pillSm",
  "pillSmLabel": "addon-sphere-row-module__SJ9uIW__pillSmLabel",
  "play": "addon-sphere-row-module__SJ9uIW__play",
  "plusBarHSm": "addon-sphere-row-module__SJ9uIW__plusBarHSm",
  "plusBarVSm": "addon-sphere-row-module__SJ9uIW__plusBarVSm",
  "plusSm": "addon-sphere-row-module__SJ9uIW__plusSm",
  "product": "addon-sphere-row-module__SJ9uIW__product",
  "productLogo": "addon-sphere-row-module__SJ9uIW__productLogo",
  "productLogoWrap": "addon-sphere-row-module__SJ9uIW__productLogoWrap",
  "products": "addon-sphere-row-module__SJ9uIW__products",
  "sphere": "addon-sphere-row-module__SJ9uIW__sphere",
  "sphereVideo": "addon-sphere-row-module__SJ9uIW__sphereVideo",
  "sphereVideoPlaying": "addon-sphere-row-module__SJ9uIW__sphereVideoPlaying",
});
